module.exports = __webpack_public_path__ + "bin/31aea4b176e2746c8c7aba228a5374e5.jpg";